import { getUserCognitoGroups } from './auth-groups.util';
import { isBrokerUser, isInsurerUser } from './get-group';

/**
 * Acesso à tela de Notificações.
 *
 * Corretora vê o próprio feed; seguradora vê o da corretora selecionada no
 * header (e a tela pede a seleção quando não há nenhuma). Assessoria fica de
 * fora nesta fase — nada é gravado para ela, e a tela só mostraria vazio.
 */
export async function requireNotificationsAccess(): Promise<boolean> {
  const groups = await getUserCognitoGroups();

  return isBrokerUser(groups) || isInsurerUser(groups);
}
